import React, { createContext, useContext, useState, useEffect } from 'react';
import axios from 'axios';
import { useLocation, useNavigate } from 'react-router-dom';
import { API_URL } from '../config/URL/URL';

const AuthContext = createContext();

export const useAuth = () => {
    const context = useContext(AuthContext);
    if (!context) {
        throw new Error('useAuth must be used within an AuthProvider');
    }
    return context;
};

export const AuthProvider = ({ children }) => {
    const location = useLocation();

    const [isLoggedIn, setIsLoggedIn] = useState(false);
    const [loggedInUser, setLoggedInUser] = useState(null);
    const [isLoading, setIsLoading] = useState(true);

    const navigate = useNavigate();

    // 컴포넌트 마운트 시 SessionStorage에서 로그인 상태 확인
    useEffect(() => {
        // console.log("auth*************")
        const checkLoginStatus = () => {
            try {
                const storedUser = sessionStorage.getItem('loggedInUser');
                const storedLoginStatus = sessionStorage.getItem('isLoggedIn');

                if (storedUser && storedLoginStatus === 'true') {
                    setIsLoggedIn(true);
                    setLoggedInUser(storedUser);
                    // console.log('SessionStorage에서 로그인 상태 복원:', storedUser);
                } else {
                    setIsLoggedIn(false);
                    setLoggedInUser(null);
                }
            } catch (error) {
                console.error('SessionStorage 읽기 실패:', error);
                setIsLoggedIn(false);
                setLoggedInUser(null);
            } finally {
                setIsLoading(false);
                // console.log("isLoading auth", isLoading)
            }
        };

        checkLoginStatus();
    }, []);

    const login = (userId) => {
        setIsLoggedIn(true);
        setLoggedInUser(userId);

        // SessionStorage에 로그인 정보 저장
        try {
            sessionStorage.setItem('isLoggedIn', 'true');
            sessionStorage.setItem('loggedInUser', userId);
        } catch (error) {
            console.error('SessionStorage 저장 실패:', error);
        }
    };

    const logout = async () => {
        // SessionStorage에서 로그인 정보 제거
        try {
            const response = await axios.post(`${API_URL}/user/logout`);
            // const response = await axios.post('http://localhost:8080/user/logout');
            
            if (response.status === 200) {
                setIsLoggedIn(false);
                setLoggedInUser(null);
                sessionStorage.removeItem('isLoggedIn');
                sessionStorage.removeItem('loggedInUser');
                navigate(location.pathname, { replace: true });
            }
        } catch (error) {
            console.error('SessionStorage 제거 실패:', error);
        }
    };

    const value = {
        isLoggedIn,
        loggedInUser,
        login,
        logout,
        isLoading
    };

    return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};
